module.exports = __webpack_public_path__ + "img/ic_car_default.1deba4a3.svg";